import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/PerfilesTable";
import MaestrasView from "../../components/1.1 maestras/Maestra";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";

const MaestraPage = () => {
  const { rut } = useParams();
  const [selectedMaestra, setSelectedMaestra] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const handlePageChange = useCallback((newPage) => {
    setCurrentPageIndex(newPage);
  }, []);

  const handlePageSizeChange = useCallback((newSize) => {
    setCurrentPageSize(newSize);
  }, []);

  const location = useLocation();

  // 1) Map route -> backend Maestra.tipo values
  const tipoByPath = {
    "/maestras": "Maestra",
    "/maestras_externas": "Maestra Externa",
    "/alumna": "Alumna",
    "/especial": "Especial",
  };

  // 2) Normalize path (remove trailing slash)
  const normalizedPath = location.pathname.replace(/\/$/, "");

  // 3) Pick tipo (default to "Maestra" if unknown)
  const tipo = tipoByPath[normalizedPath] || "Maestra";

  useEffect(() => {
    if (rut) {
      setLoadingDetail(true);
      fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${rut}/`)
        .then((response) => response.json())
        .then((data) => {
          setSelectedMaestra(data);
          setShowModal(true); // <== ADD THIS LINE
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching maestra:", error);
          setLoading(false);
        })
        .finally(() => {
          setLoadingDetail(false);
        });
    } else {
      setLoading(false);
    }
  }, [rut]);

  const handleMaestraSelect = (maestra) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedMaestra(null);

    fetch(
      `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestra.rut}/`,
    )
      .then((res) => res.json())
      .then((data) => {
        setSelectedMaestra(data);
        setShowModal(true); // Only now show the modal
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => {
        setLoadingDetail(false);
      });
  };

  const columns = [
  {
    Header: "Nombre",
    accessor: "nombre",
    Cell: ({ row }) => {
      const item = row.original;

      const groups = Array.isArray(item?.grupos_whatsapp)
        ? item.grupos_whatsapp
        : [];

      const groupNames = groups
        .map((g) => g?.nombre)
        .filter(Boolean);

      return (
        <div className="d-flex align-items-center flex-wrap gap-1">
          <span>{item?.nombre ?? ""}</span>

          {/* SEC badge */}
          {item?.sec === true && (
            <span className="badge bg-info">SEC</span>
          )}

          {/* WhatsApp groups as badges */}
          {groupNames.map((name) => (
  <span
    key={name}
    className="badge bg-light text-dark"
    title={name} // full name on hover
  >
    {truncate(name, 10)}
  </span>
))}

        </div>
      );
    },
  },
  { Header: "Comuna", accessor: "comuna" },
  { Header: "Oficio", accessor: "oficio" },
];


  if (loading) return <LoadingOverlay />;

  function truncate(text, max = 10) {
    if (!text) return "";
    return text.length > max ? `${text.slice(0, max)}…` : text;
  }

  return (
    <>
      {/* Show overlay during initial page load or detail fetch */}
      {(loading || loadingDetail) && <LoadingOverlay />}

      <div className="maestra-page capsule">
        <GenericTable
          apiUrl={`${process.env.REACT_APP_BASE_API}api/perfiles/tabla/maestras/?tipo=${encodeURIComponent(tipo)}`}
          columns={columns}
          onRowClick={handleMaestraSelect}
          category="maestras"
          title={tipo}   
          initialPageIndex={currentPageIndex}
          onPageChange={handlePageChange}
          pageSize={currentPageSize}
          onPageSizeChange={handlePageSizeChange}
        />

        {/* Modal shows only when we have data */}
        {showModal && selectedMaestra && (
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="maestra-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
              <MaestrasView maestra={selectedMaestra} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default MaestraPage;
